/* unplugin-vue-components disabled */import script from "./Tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=abeba6bc&lang=css"

const __exports__ = script;

export default __exports__